<template>
    <div>
        <v-card>
            <v-card-title>Insert Late Ticket Number</v-card-title>
            <v-card-text>
                <div class="px-2">
                    <div class="flex flex-wrap justify-start content-center items-center -mx-4">
                         <div class="w-full md:w-1/2 px-2">
                             <v-text-field v-model="lateticket.ticketNumber"  prepend-icon="list" label="Late Ticket Number" :rules="[rules.requiredRule]"></v-text-field>
                         </div>
                        <div class="w-full md:w-1/2 px-2">
                            <v-select v-model="lateticket.violationType" :loading="isLoadingViolationTypes" prepend-icon="list"
                                          :items="violationTypes" item-text="violation_label" item-value="violation_type"
                                          label="Violation Type" :rules="[rules.requiredRule]"
                                ></v-select>
                        </div>
                    </div>
                </div>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="clear" color="error">Clear</v-btn>
                <v-btn :loading="loadingSubmitButton" @click="save" color="success">Submit</v-btn>
            </v-card-actions>
        </v-card>
        <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
            {{ snackText }}
            <v-btn text @click="snack = false">Close</v-btn>
        </v-snackbar>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                appURL: process.env.MIX_APP_URL,
                loadingSubmitButton: false,
                isLoadingViolationTypes:false,
                violationTypes: [],
                snack: false,
                snackColor: '',
                snackText: '',
                rules: {
                    requiredRule: value => !! value || 'Required',
                },
                lateticket: {
                    ticketNumber: '',
                    violationType: '',
                },
            }
        },
        created() {
            this.fetchViolationTypes();

        },
        methods: {
            save: function() {
                this.loadingSubmitButton = true;
                axios.post(this.appURL + '/api/lateticket/', {
                    ticket_number: this.lateticket.ticketNumber,
                    violation_type: this.lateticket.violationType,
                }).then((response) => {
                    if(response.status === 200)
                    {
                        this.snack = true;
                        this.snackColor = 'success';
                        this.snackText = 'Ticket Entered Successfully!';
                    }
                }).catch(error => {
                    if (error.response.status === 404) {
                        this.snack = true;
                        this.snackColor = "error";
                        this.snackText = error.response.data.message;
                    } else {
                        this.snack = true;
                        this.snackColor = "error";
                        this.snackText = "Oops! Something went wrong!";
                    }
                }).finally(() => {
                    this.loadingSubmitButton = false;
                    this.clear();
                });
            },
            clear: function() {
                this.lateticket.ticketNumber = '';
                this.lateticket.violationType = '';

            },
            async fetchViolationTypes() {
                this.isLoadingViolationTypes = true;
                await axios.get(this.appURL + '/api/lateticket')
                .then((response) => {
                    if(response.status === 200) {
                        this.violationTypes = response.data;
                    }
                }).catch(error => {
                    this.snack = true;
                    this.snackColor = 'error';
                    this.snackText = 'Oops! Something went wrong!'
                }).finally(() => this.isLoadingViolationTypes = false);
            },
        }
    }
</script>
